// utils/preloadImages.js
export const preloadImages = (paths) =>
  Promise.all(
    paths.map(
      (src) =>
        new Promise((resolve) => {
          const img = new Image();
          img.src = src;

          // decode() guarantees the browser has finished parsing pixels
          if (img.decode) {
            img.decode().catch(() => {}).then(resolve);
          } else {
            img.onload = img.onerror = resolve;
          }
        }),
    ),
  );
